<template>
  <div>
    <v-card
      class="mx-auto my-2 pa-6 body-2"
      :style="
        $vuetify.theme.dark
          ? 'color: rgba(255,255,255,0.7);'
          : 'color: rgba(0,0,0,0.7);'
      "
    >
      <div class="mb-4">
        <h1>
          {{ $t("createNewEvent.drawer") }}
        </h1>
      </div>
      {{ $t("createNewEvent.description") }}
      <br />
      {{ $t("createNewEvent.setResult") }}
    </v-card>

    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="6">
            <CreateEvent @fetchCreatedEvents="fetchCreatedEvents" />
          </v-col>
          <v-spacer />
          <v-col
            cols="6"
            class="d-flex flex-row-reverse d-md-none d-lg-none d-xl-none"
          >
            <div>
              <v-btn-toggle dense>
                <v-btn @click="breakpoint = 0">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>

                <v-btn @click="breakpoint = 'xs'">
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
          <v-spacer />
          <v-col cols="12" md="3">
            <v-text-field
              :class="
                $vuetify.breakpoint.smAndDown ? 'mt-3 align-self-end' : ''
              "
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :loading="loading"
        :loading-text="loadingText"
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="10"
        :mobile-breakpoint="breakpoint"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.event_id="{ item }">
          <v-btn @click="$copy(item.event_id)" x-small>
            {{ item.event_id }}
          </v-btn>
        </template>

        <template v-slot:item.active="{ item }">
          <v-chip :color="item.active.color" outlined small>
            {{ item.active.text }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn-toggle>
            <EditEvent
              :event="item"
              :fetchingOddsForEvent="fetchingOddsForEvent"
              @fetchingEventOdds="fetchingEventOdds"
              @refresh="fetchCreatedEvents"
            />
          </v-btn-toggle>
        </template>

        <template v-slot:no-data>
          {{ $t("noMainEvents") }}
          <a
            @click.prevent="
              canListEvents &&
                $router.push({
                  path: `/${
                    isCollaborator ? 'collaborator' : 'administrator'
                  }/events/list`,
                })
            "
          >
            {{ $t("events") }}
          </a>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import CreateEvent from "./create";
import EditEvent from "./edit";

export default {
  data: () => ({
    currentStatus: 0,

    items: [],
    search: "",
    breakpoint: 0,
    loading: false,

    colors: {
      1: "green darken-4",
      2: "green accent-4",
      9: "green darken-1",
      4: "red darken-1",
      7: "red lighten-2",
      5: "purple darken-1",
      3: "amber accent-4",
      6: "amber darken-1",
    },

    fetchingOddsForEvent: 0,
  }),

  components: { CreateEvent, EditEvent },

  created() {
    this.fetchCreatedEvents();
  },

  computed: {
    isCollaborator() {
      return JSON.parse(localStorage.getItem("user_data")).isCollaborator;
    },
    statusItems() {
      return [
        { text: this.$t("all"), value: 0, color: this.colors[0] },
        { text: this.$t("actives"), value: 1, color: this.colors[1] },
        { text: this.$t("canceled"), value: 2, color: this.colors[2] },
        { text: this.$t("postponed"), value: 3, color: this.colors[3] },
        { text: this.$t("suspended"), value: 4, color: this.colors[4] },
      ];
    },
    headers() {
      const headers = [
        { text: "Id", value: "event_id" },
        { text: this.$t("country"), value: "country_name" },
        { text: this.$t("sport"), value: "sport_name" },
        { text: this.$t("event"), value: "teams" },
        { text: this.$t("tournament"), value: "league_name" },
        { text: this.$t("dateTime"), value: "event_date" },
        { text: this.$t("status"), value: "active", align: "center" },
      ];

      if (this.canSetResult) {
        headers.push({
          text: this.$t("actions"),
          value: "actions",
          align: "center d-print-none",
        });
      }

      return headers;
    },
    loadingText() {
      return this.$t("loadingEvents");
    },
    canSetResult() {
      return this.$permission("76");
    },
    canListEvents() {
      return this.$permission("76");
    },
    canRemoveMainEvent() {
      return this.$permission("59");
    },
  },

  watch: {
    currentStatus() {
      this.fetchCreatedEvents();
    },
  },

  methods: {
    fetchingEventOdds(eventId) {
      this.fetchingOddsForEvent = eventId;
    },

    fetchCreatedEvents() {
      this.loading = true;
      this.items = [];

      this.$axios
        .get(`/${this.$prefix()}/manualEvents/events/listEvents`)
        .then((res) => {
          const events = res.data.dados;

          events.forEach((item) => {
            item.active = {
              status: item.status,
              text: this.$legends.eventsActive(item.status),
              color: this.colors[item.status],
            };

            if (item.event_date) {
              item.realDate = new Date(item.event_date.replace(" ", "T"));

              item.event_date = new Date(
                item.event_date.replace(" ", "T")
              ).toLocaleString();
            }

            item.fetchingOdds = false;
          });

          this.items = events;
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
